var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1475 20.5H7.14746C4.14746 20.5 2.14746 19 2.14746 15.5V8.5C2.14746 5 4.14746 3.5 7.14746 3.5H17.1475C20.1475 3.5 22.1475 5 22.1475 8.5V15.5C22.1475 19 20.1475 20.5 17.1475 20.5Z",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64746 18C9.02817 18 10.1475 16.8807 10.1475 15.5C10.1475 14.1193 9.02817 13 7.64746 13C6.26675 13 5.14746 14.1193 5.14746 15.5C5.14746 16.8807 6.26675 18 7.64746 18Z",
    stroke: "#FDB913",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1475 9L5.14746 9",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1475 16L13.1475 16",
    stroke: "#FDB913",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconCheck);
export default __webpack_public_path__ + "static/media/profile-icon-check.695745037e438fa8a84ebfcd7ceced45.svg";
export { ForwardRef as ReactComponent };